<template>
  <v-skeleton-loader type="image" transition="fade-transition" :loading="$apollo.queries.numbers.loading">
    <div>
      <v-row class="px-3 pb-3" justify="end">
        <add-number-external-provider />
      </v-row>
      <v-card class="multi-numbers" min-height="250">
        <v-card-title class="pb-3">
          <span class="table-card-title pl-0 mb-5">Números de disparo</span>

          <v-spacer />
          <export-data :data-fetcher="getDataToExport" filename="disparadores_whatsapp" ghost class="mx-2" />
          <mf-search v-model="search" outlined hide-details placeholder="Buscar disparador" />
        </v-card-title>
        <v-card-text v-if="!numbers.length">
          <v-container class="pa-0" fluid fill-height>
            <v-row justify="center" align="center">
              <div class="void-numbers">
                <v-container class="pa-0" fluid fill-height>
                  <v-row justify="center" align="center">
                    <p class="text-info">Nenhum número foi adicionado ainda</p>
                    <mf-button label="Adicionar número" @click="openNumberDialog" />
                  </v-row>
                </v-container>
              </div>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-text v-else class="px-0">
          <v-data-table :items="items" :headers="headers" :items-per-page="5" :footer-props="{ itemsPerPageOptions: [5, 10, 15, -1] }">
            <template v-slot:header.nof_contacts="{ header }">
              {{ header.text }}

              <v-tooltip top max-width="245">
                <template v-slot:activator="{ on }">
                  <span v-on="on">
                    <mf-icon small color="cinza-0">info</mf-icon>
                  </span>
                </template>
                <span>Um contato é um número de whatsapp que se inscreveu nesse canal mandando mensagem para o número divulgado.</span>
              </v-tooltip>
            </template>

            <template v-slot:header.nof_community_contacts="{ header }">
              {{ header.text }}

              <v-tooltip top max-width="245">
                <template v-slot:activator="{ on }">
                  <span v-on="on">
                    <mf-icon small color="cinza-0">info</mf-icon>
                  </span>
                </template>
                <span>Um contato na comunidade é um número de whatsapp que se inscreveu em alguma das comunidades atreladas a este disparador.</span>
              </v-tooltip>
            </template>
            <template v-slot:item="{ item }">
              <tr>
                <td>
                  <mf-icon fill :color="statusColor(item.connection_status)">fiber_manual_record</mf-icon>
                  {{ statusText(item.connection_status) }}
                </td>
                <td>
                  {{ item.name }}
                </td>
                <td>
                  {{ formatNumber(item.number) }}
                </td>
                <td>
                  {{ item.nof_contacts | localeString(0) }}
                </td>
                <td>
                  {{ item.nof_community_contacts | localeString(0) }}
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </div>
  </v-skeleton-loader>
</template>

<script>
import { phoneNumberFormat } from '@/helpers/phoneNumberFormat.js'
import { QUERY_GET_NUMBERS, QUERY_MAX_NUMBER_OF_SENDERS } from '@/modules/campanhas/whatsapp/graphql/index.js'
import whatsappStatusMixin from '@/modules/campanhas/whatsapp/mixins/whatsapp-status.js'

export default {
  components: {
    AddNumberExternalProvider: () => import('@/modules/campanhas/whatsapp/views/components/AddNumberExternalProvider.vue'),
    ExportData: () => import('@/components/export-data/ExportData.vue'),
  },
  mixins: [whatsappStatusMixin],
  data: () => ({
    numbers: [],
    maxQuantityOfNumbers: 0,
    search: null,
    items: [],
  }),
  computed: {
    headers() {
      return [
        {
          text: 'Status',
          value: 'connection_status',
          sortable: true,
          width: '15%',
        },
        {
          text: 'Nome',
          value: 'name',
          sortable: true,
          width: '29%',
        },
        {
          text: 'Número',
          value: 'number',
          sortable: true,
          width: '20%',
        },
        {
          text: 'Contatos',
          value: 'nof_contacts',
          sortable: true,
          width: '15%',
        },
        {
          text: 'Contatos na comunidade',
          value: 'nof_community_contacts',
          sortable: true,
          width: '15%',
        },
      ]
    },
    isAdmin() {
      return this.$getIsAdmin()
    },
  },
  apollo: {
    numbers: {
      query: QUERY_GET_NUMBERS,
      update({ getNumbers }) {
        this.items = getNumbers
        return getNumbers
      },
    },
    maxQuantityOfNumbers: {
      query: QUERY_MAX_NUMBER_OF_SENDERS,
      update({ getMaxNofSenders }) {
        return getMaxNofSenders
      },
    },
  },
  watch: {
    search: {
      handler(value) {
        if (value) {
          this.items = this.numbers.filter((number) => {
            return number.name.toLowerCase().includes(value.toLowerCase()) || number.number.includes(value)
          })
          return
        }
        this.items = this.numbers
      },
      immediate: true,
    },
  },
  methods: {
    openNumberDialog() {
      this.numberDialog = true
    },
    refresh() {
      this.$apollo.queries.numbers.refetch()
    },
    formatNumber(number) {
      return phoneNumberFormat(number)
    },
    getDataToExport() {
      const headers = ['Status', 'Nome', 'Número', 'Contatos', 'Contatos na comunidade']
      const rows = this.items.map((item) => {
        return [this.statusText(item.connection_status), item.name, this.formatNumber(item.number), item.nof_contacts, item.nof_community_contacts]
      })
      return { headers, rows }
    },
  },
}
</script>

<style lang="scss">
.multi-numbers {
  .void-numbers {
    margin-top: 40px;
  }

  th {
    @extend .column-title;
  }
  td {
    @extend .texto-corrido;
  }
  .text-info {
    opacity: 0.5;
    font-size: 18px;
    font-weight: bold;
    line-height: 1.22;
    letter-spacing: 0.29px;
    text-align: center;
    color: $preto;
  }
  .numbers-quantity {
    opacity: 0.5;
    font-size: 15px;
    line-height: 1.2;
    letter-spacing: 0.24px;
  }
  .max-numbers-message {
    opacity: 0.5;
    font-size: 12px;
    line-height: 1.25;
    letter-spacing: 0.19px;
    margin-left: 8px;
  }
  .numbers-list {
    user-select: none;
    .smartphone {
      opacity: 0.5;
    }
    .name {
      opacity: 0.8;
      font-size: 12px;
      line-height: 1.25;
      letter-spacing: 0.19px;
      color: $preto;
    }
    .number {
      opacity: 0.8;
      font-size: 15px;
      font-weight: bold;
      line-height: 1.2;
      letter-spacing: 0.24px;
      color: $preto;
    }
    .status {
      opacity: 0.5;
      font-size: 12px;
      line-height: 1.25;
      letter-spacing: 0.19px;
      color: $preto;
    }
  }
}
</style>
